import { AlertTriangle } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

// Nombre de chiffres attendu sans le 0 initial, selon l'indicatif
const EXPECTED = { "+33": 9, "+32": [8, 9], "+41": 9, "+44": 10, "+49": [10, 11], "+31": 9, "+39": [9, 10], "+34": 9, "+351": 9, "+352": [6, 9] };

export const phoneIssue = (phone, code = "") => {
  const raw = (phone || "").trim();
  if (!raw) return "";
  const m = raw.match(/^\s*(?:\+|00)(\d{1,3})[\s.\-/(]/);
  const c = m ? `+${m[1]}` : (code || "+33");
  let d = (m ? raw.slice(m[0].length - 1) : raw).replace(/\(0\)/g, "").replace(/\D/g, "");
  if (d.startsWith("0")) d = d.slice(1);
  const exp = EXPECTED[c];
  const [min, max] = Array.isArray(exp) ? exp : exp ? [exp, exp] : [6, 13];
  if (d.length < min) return "short";
  if (d.length > max) return "long";
  return "";
};

export const PhoneWarn = ({ phone, code, testid = "phone-warn" }) => {
  const { t } = useI18n();
  const issue = phoneIssue(phone, code);
  if (!issue) return null;
  return (
    <p className="mt-1 flex items-center gap-1 text-[11px] text-amber-700" data-testid={testid}>
      <AlertTriangle className="w-3 h-3 shrink-0" />
      {t(issue === "short" ? "Numéro trop court : il manque des chiffres." : "Numéro trop long : vérifiez les chiffres.")}
    </p>
  );
};
